import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import Header from '../../components/Header';
import CurrentTab from './CurrentTab';
import ConversionsTab from './ConversionsTab';
import ProductsTab from './ProductsTab';
import AdCopyTab from './AdCopyTab';
import ABTestTab from './ABTestTab';

const TAB_NAMES = ['current', 'conversions', 'products', 'adcopy', 'abtest'] as const;
type TabName = (typeof TAB_NAMES)[number];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`ad-evaluation-tabpanel-${index}`}
      aria-labelledby={`ad-evaluation-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

const AdEvaluation: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get('tab') || 'current';
  const tabName = TAB_NAMES.includes(tabParam as TabName) ? (tabParam as TabName) : 'current';
  const activeTab = TAB_NAMES.indexOf(tabName);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    const newTabName = TAB_NAMES[newValue];
    const params = new URLSearchParams();
    params.set('tab', newTabName);
    setSearchParams(params);
  };

  return (
    <Box m="20px">
      <Header
        title="DOI/Website Ads"
        subtitle="Auswertung der Werbeplatzierungen auf DOI- und Artikelseiten — Conversions, Produkt-Performance & AI Ad Copy"
      />

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={activeTab} onChange={handleTabChange} aria-label="ad evaluation tabs">
          <Tab label="Aktuell" />
          <Tab label="Conversions" />
          <Tab label="Produkte" />
          <Tab label="Ad Copy" />
          <Tab label="A/B Test" />
        </Tabs>
      </Box>

      <TabPanel value={activeTab} index={0}>
        <CurrentTab />
      </TabPanel>

      <TabPanel value={activeTab} index={1}>
        <ConversionsTab />
      </TabPanel>

      <TabPanel value={activeTab} index={2}>
        <ProductsTab />
      </TabPanel>

      <TabPanel value={activeTab} index={3}>
        <AdCopyTab />
      </TabPanel>

      <TabPanel value={activeTab} index={4}>
        <ABTestTab />
      </TabPanel>
    </Box>
  );
};

export default AdEvaluation;
